import { NgModule } from '@angular/core';
import { MalihuScrollbarDirective } from './malihu-scrollbar.directive';
import { MalihuScrollbarService } from './malihu-scrollbar.service';
export var MalihuScrollbarModule = (function () {
    function MalihuScrollbarModule() {
    }
    MalihuScrollbarModule.forRoot = function () {
        return {
            ngModule: MalihuScrollbarModule,
            providers: [MalihuScrollbarService],
        };
    };
    MalihuScrollbarModule.forChild = function () {
        return {
            ngModule: MalihuScrollbarModule,
        };
    };
    MalihuScrollbarModule.decorators = [
        { type: NgModule, args: [{
                    exports: [MalihuScrollbarDirective],
                    declarations: [MalihuScrollbarDirective],
                    providers: [MalihuScrollbarService],
                },] },
    ];
    /** @nocollapse */
    MalihuScrollbarModule.ctorParameters = function () { return []; };
    return MalihuScrollbarModule;
}());
//# sourceMappingURL=malihu-scrollbar.module.js.map


//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/ngx-malihu-scrollbar/dist/lib/malihu-scrollbar.module.js
// module id = ../../../../ngx-malihu-scrollbar/dist/lib/malihu-scrollbar.module.js
// module chunks = 4